var map = {
	"./bayern.jpg": 1187,
	"./borussia.jpg": 7478,
	"./hamburger.jpg": 6113,
	"./nurnberg.jpg": 5649,
	"./schalke.jpg": 4849,
	"./stuttgart.jpg": 7784
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7531;